var map = {
	"./DailyInvite.vue": 88032,
	"./airdrop.vue": 52085,
	"./airdrop2.vue": 5706,
	"./airdropReward.vue": 56470,
	"./boost.vue": 17685,
	"./code.vue": 92354,
	"./earn.vue": 79042,
	"./frens.vue": 77453,
	"./index.vue": 2882,
	"./join.vue": 78746,
	"./lottery.vue": 18733,
	"./lotteryDetail.vue": 43047,
	"./mine.vue": 87904,
	"./rank.vue": 93235,
	"./sign.vue": 77680,
	"./squad.vue": 56554,
	"./taskDetail.vue": 91131
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 68239;